import React from 'react';
import Image from 'gatsby-image';
import { v1 as uuid } from 'uuid';
import classNames from 'classnames';
import Container from '../container';
import Row from '../row';
import Col from '../col';
import styles from './rheia-case-study.module.scss';

const RheiaCaseStudy = ({ slice }) => {
  const {
    case_study_content, // html
    case_study_title // text
  } = slice.primary;

  return (
    <section className={ classNames( styles.section) } >
      <Container>
        <Row gutter={{ base: '3rem', md: '5rem' }}>
          <Col md={8}>
            <div className={ styles.mainContent }>
              <h2 className={ styles.title }>{ case_study_title.text }</h2>

              <div
                dangerouslySetInnerHTML={{ __html: case_study_content.html }}
              />
            </div>
          </Col>
          <Col
            md={4}
            className={ classNames(styles.rightContent) }
          >
            { !! slice.items.length && slice.items.map( item => (
              <div key={uuid()}>
                <Image fluid={ item.sub_image.fluid } alt={ item.sub_image_alt_text.text } />

                <div
                  className={ styles.altText }
                >
                  {item.sub_image_alt_text.text}
                </div>
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default RheiaCaseStudy;
